import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { EventsApiService } from 'features/events';
import { queryClient } from 'providers';

import { eventsQueryKeys } from './query-keys';
const { createTipsAdvice } = EventsApiService();

export const useCreateTipsAdvice = (id: any) => {
    const { message } = App.useApp();

    return useMutation(
        (payload: any) => {
            return createTipsAdvice(payload);
        },
        {
            onError: (error) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: eventsQueryKeys.all,
                });
                if (id) {
                    message.success("Tips & Advice has been updated successfully!!");
                } else {
                    message.success("Tips & Advice has been created successfully!!");
                }
            },
        },
    );
};
